import { render, staticRenderFns } from "./BindingAccount.vue?vue&type=template&id=70b0a74a&scoped=true&"
import script from "./BindingAccount.vue?vue&type=script&lang=js&"
export * from "./BindingAccount.vue?vue&type=script&lang=js&"
import style0 from "./BindingAccount.vue?vue&type=style&index=0&id=70b0a74a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b0a74a",
  null
  
)

export default component.exports